export default __webpack_public_path__ + "static/media/arrowLeft.4857a587.svg";